<script>
import convert from 'color-convert';
import { onMount} from 'svelte';
import { fade} from 'svelte/transition';
//@ts-ignore
import {coordinates,setBase} from './coordinates';
import share from './share';
//@ts-ignore
import Modal from './share/modal.svelte';

let canvasContainer;
let canvas;
let selected = {parameter:'', color:''};
let crName = '';
let coordinate = null;
let ctx;
let stream;
let offscreen;
let offscreenCtx;
let video;
let filter;
let group = 'parameter';
let selected_color;
let base;
let baseDisplay;
let keepTick = true;
let fileinput;
let media;
let prevMedia;
let isImageLoaded = false;
let isVideoStarted = false;
let isRatioChangable = false;
let isOpen = false;
let videoStream;
let scaleRatio;
let isScrollable = false;
let midCanvas;
let midCtx;
let pbody;
let dialogData = {canvas:null, scale:1};
let ratioPatterns = Array.from({length:10}, (_, i) =>  {
   let base = (i +1 ) * 10;
   let value = base / 100;
   let text = `${base}%`;
   return {value, text};
})



onMount(() => {


    ctx = canvas.getContext("2d");
    offscreen = document.createElement("canvas");
    offscreenCtx = offscreen.getContext("2d");
    midCanvas = document.createElement("canvas");
    midCtx = midCanvas.getContext("2d");

    video = document.createElement("video");


});
$: {
  if(group === 'parameter'){
    if(crName !== selected.parameter){
      changeParameterCoordinate();
    }
  }
  else{
    if(crName !== selected.color){
      changeColorGrouper();
    }
  }
}
function changeParameterCoordinate(){
  changeCoordinate(selected.parameter);
}
function changeCoordinate(coordinateName){

  crName = coordinateName;
  coordinate = coordinates[coordinateName];
  if(isVideoStarted === false){
    processImage();
  }
}
function changeColorGrouper(){
  setBase(selected.color, base);
  changeCoordinate(selected.color)

}
function handleCameraInitialize(){
  navigator.mediaDevices.getUserMedia({
     video: true
  }).then((stream) =>{
      isImageLoaded = true;
      video.srcObject = stream;
      videoStream = stream;
      video.onloadedmetadata = () => {
        video.play();
        isVideoStarted = true;
        dialogData.scale = 1;
        dialogData.canvas = canvas;

        canvas.width = offscreen.width = video.videoWidth;
        canvas.height = offscreen.height = video.videoHeight;
        midCtx.clearRect(0, 0, canvas.width, canvas.height);
        dialogData.canvas


        tick();
      };
  }).catch(function(err) {

     console.log(err);
  });
}
function triggerFileread(){
  fileinput.click();
}
function handleFileRead(e){
    if(!e.target.files || e.target.length === 0){
          return;
    }

    if(isVideoStarted === true){
      videoStream.getTracks().forEach(track => track.stop());
      video.pause();
      video.removeAttribute('src');
      video.removeAttribute('srcObject');
      video.load();
      isVideoStarted = false;
    }
    let image = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(image);
    reader.onload = e => {
      isImageLoaded = true;
      let image = new Image();
      image.src = reader.result;
      image.onload = () => {
        isScrollable = false;
        offscreen.width = image.width;
        offscreen.height = image.height;
        offscreenCtx.drawImage(image, 0, 0);
        if(canvasContainer.clientWidth < image.width){
          isRatioChangable = true;
          dialogData.canvas = midCanvas;
          let prevPattern;
          for (let ratioPattern of ratioPatterns) {
            if(canvasContainer.clientWidth < ratioPattern.value * image.width){
              scaleRatio = prevPattern;
              dialogData.scale = prevPattern.value;
              handleScaleChange();
              break;
            }
            prevPattern = ratioPattern;
          }

        }
        else{
          isRatioChangable = false;
          dialogData.canvas = canvas;
          dialogData.scale = 1;
          canvas.width= image.width;
          canvas.height = image.height;
          processImage();

        }

      }
    };
}

function handleCanvasClick(e){
    if(isImageLoaded === false || group !== 'color'){
      return;
    }



    let rect = e.target.getBoundingClientRect()
    let sx = e.clientX - rect.left;
    let sy = e.clientY - rect.top;
    base = [...offscreenCtx.getImageData(sx, sy, 1,1).data];
    base.pop();
    let hex = convert.rgb.hex(base);
    if(!baseDisplay){
      setTimeout(()=>{
        baseDisplay.style.backgroundColor = `#${hex}`
      })
    }
    else{
      baseDisplay.style.backgroundColor = `#${hex}`;
    }

    changeColorGrouper();



}
function handleSaveButton(){
  keepTick = false;
  isOpen = true;

}
function handleModalClose(){
  keepTick = true;
}
function tick(){
  if(isOpen === false){
    offscreenCtx.drawImage(video, 0, 0);

    processImage();
  }


  window.requestAnimationFrame(tick);
}
function processImage(){



   const imageData = offscreenCtx.getImageData(0, 0, offscreen.width, offscreen.height);

   if(coordinate){
       coordinate(imageData);
   }
   if(isVideoStarted === false && isRatioChangable === true){
      let midCanvas = document.createElement("canvas");
      let miCtx = midCanvas.getContext('2d');
      midCanvas.width = offscreen.width;
      midCanvas.height = offscreen.height;
      midCtx.putImageData(imageData, 0, 0);
      ctx.drawImage(midCanvas, 0, 0, midCanvas.width * scaleRatio.value, midCanvas.height * scaleRatio.value);



   }
   else{
      ctx.putImageData(imageData, 0, 0);
   }





};
function handleScaleChange(){

  canvas.height =  scaleRatio.value * offscreen.height;
  canvas.width =  scaleRatio.value * offscreen.width;

  processImage();
}

</script>
<div id='gurd'>
<div id='main'>
  <form id="ui_form">
    <div id='control_panel'>
      <div class='form_row'>
        <p class='note'>▼画像はどこから?</p>
        <div id='sauce_selecter'>
          <button type="button" on:click={handleCameraInitialize}>カメラ</button>
          <button type="button" on:click={triggerFileread}>アプリやファイル</button>
          <input type="file"  bind:this={fileinput} on:change={handleFileRead} accept=".jpg, .jpeg, .png"/>
        </div>
      </div>
      {#if isImageLoaded === true}
      <div transition:fade>
        <div class='form_row'>
          <p class='note'>▼どんな風に変換する?</p>
          <label><input type="radio" name="group" bind:group={group} value='parameter' checked="checked"/>鮮やかさや明るさを白黒で</label>
          <label><input type="radio" name="group" bind:group={group} value='color'/>色との距離を鮮やかさで</label>
        </div>
        {#if group === 'parameter'}
          <div class="select_box">
            <select bind:value={selected.parameter} on:bluer={changeParameterCoordinate} on:change={changeParameterCoordinate}>
              <option value=''>フィルタ無し</option>
              <option value="hsvValue">明るいものほど白く</option>
              <option value="hsvSaturation">鮮やかなものほど白く</option>
            </select>
          </div>
        {/if}
        {#if group === 'color'}
          <div class="select_box">
            <div class="form_subarea">
              <p>
                {#if base}基準にする色:<div id='baseDisplay' bind:this={baseDisplay}></div>{:else}画像を押して基準にする色を選んでください{/if}
              </p>
            </div>
            <select bind:value={selected.color} on:bluer={changeColorGrouper} on:change={changeColorGrouper} disabled={!base}>
              <option value=''>フィルタ無し</option>
              <option value="groupHue">色の近いもの</option>
              <option value="groupSaturation">鮮やかさの近いもの</option>
              <option value="groupValue">明るさの近いもの</option>
            </select>
            </div>
        {/if}
        <div id='savecontainer'>
          <button type='button' on:click={handleSaveButton}>保存・シェア</button>
        </div>
      </div>
      {/if}
      {#if isRatioChangable}
        <div id="scroll_ratio">
          <select class='small_input' bind:value={scaleRatio} on:change={handleScaleChange}>
          {#each ratioPatterns as ratioPattern}
            <option value={ratioPattern}>
              {ratioPattern.text}
            </option>
          {/each}
          </select>
        </div>
      {/if}
    </div>
  </form>

  <div bind:this={canvasContainer} id="canvas_container" class:scrollable={isScrollable} class:waiting={isImageLoaded === false}>
    <canvas
    	bind:this={canvas}
    	on:click={handleCanvasClick}
    ></canvas>
  </div>

</div>
</div>
<Modal bind:isOpen={isOpen} bind:data={dialogData} on:close={handleModalClose} />
<style>
div, p{
  margin: 0;
  padding: 0;
}
label{
  display: inline-block;
  padding:　0em 0em 0.4em 0.4em;
}
#gurd{
  padding-top:1.5em;
}
#main {
  margin-left:5%;
  margin-right: 5%;

  margin-bottom: 1.5em;
  border-radius: 5px;
  background-color: white;
  padding-bottom: 0.5em;
}
#baseDisplay{
  width:3em;
  height: 1em;
  display:inline-block;
}
#canvas_container {
    width:100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;


}

#ui_form{
  width:100%;
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}
input[type="radio"]{
    margin-right: 0.2em;
}
.note{
    font-weight: bold;

}
.form_row{
  padding-top:1em;
}
.select_box{
  padding-left:0.4em;
}
.form_subarea{
  margin-bottom:0.4em;
}

#savecontainer {
  padding-top: 0.75em;
  margin-bottom: 1em;

}
#savecontainer button{
  width:100%;
  margin-left: 0px;
  margin-right: 0px

}

#sauce_selecter{
  padding-left: 0.4em;
}
#sauce_selecter button{
  margin-right:0.4em;
}
input[type=file]{
  display: none;
}
.small_input {
  padding: 0.2em;
}
.scrollable {
  overflow: scroll;
}
.waiting canvas{

  display: none;
}

</style>
